// extracted by mini-css-extract-plugin
export const feed__item = "feed-module--feed__item--3ZeoJ";
export const feed__itemTitle = "feed-module--feed__item-title--j_Plo";
export const feed__itemTitleLink = "feed-module--feed__item-title-link--1DKZB";
export const feed__itemDescription = "feed-module--feed__item-description--zlckF";
export const feed__itemMetaTime = "feed-module--feed__item-meta-time--POUpg";
export const feed__itemMetaDivider = "feed-module--feed__item-meta-divider--2yfw4";
export const feed__itemMetaCategoryLink = "feed-module--feed__item-meta-category-link--2ce-S";
export const feed__itemReadmore = "feed-module--feed__item-readmore--2cURp";